const Input = ({
  value,
  onChange,
  label,
  name,
  placeholder = '',
  disabled = false,
  type = 'text',
}) => {
  return (
    <div className="w-full">
      <label className="mb-2.5 block text-black dark:text-white">{label}</label>
      <input
        disabled={disabled}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full rounded border-[1.5px] border-stroke bg-transparent py-3 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
      />
    </div>
  );
};

export default Input;
